<script setup>
import {defineProps, defineEmits, ref, onMounted} from "vue";
import SvgBlock from "@/views/report_slide/components/SvgBlock.vue";

const props = defineProps({
  element: String,
})
const elements = {
        "toc": "Содержание",
        "icon_selector": "Фигура по условию",
        "abc": "Тезисы и % негатива по странам",
        "top20": "ТОП20 таблица",
        "country_summary": "Таблица-Резюме по стране",
        "keywords_list": "Список запросов",
        "negative_links_counter": "Счетчик нежелательных ссылок по стране",
        "snippets": "Примеры выдачи (сниппеты)",
        "ch_overflow": "Изменяемый при наложении",
        "wiki": "Википедия",
        "hints": "Подсказки",
        "knowledge": "Блок знаний",
        "search_block": "Поисковый блок (картинки/видео/похожие)",
        "delete_if_has_data": "Удалить текущий, если есть данные из настроек",
        "pdf": "Базы данных"

      }

function removeElement(){

}

</script>

<template>
  <div>
    <div class="element">
      <div class="name">{{elements[element.element]}} </div>
      <a href="" @click="removeElement" class="delete"><i class="bi bi-trash3 text-danger"></i></a>
    </div>
<!--    <SvgBlock v-if="element.icon" :icon="{name: element.icon}"></SvgBlock>-->
  </div>
</template>

<style scoped>
.element{
  z-index: 100;
  position: relative;
  justify-content: space-between;
  background: #fff;
      margin: 0 auto;
    padding: 10px;
    border: 2px solid #999;
    border-radius: 10px;
    font-size: 20px;
    display: flex;
    gap: 10px;
}
</style>